import * as React from 'react'

import {
  FilterType,
  buildPerformanceReviewsDataTableFilter,
  usePerformanceReviewsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { StatusTag } from '../helpers/StatusTag'

export const statusFilter = (source: ReturnType<typeof usePerformanceReviewsDataTable>) => {
  const options = [
    {
      label: i18n.t('performance_process.reviews.review_status.draft'),
      value: 'draft',
      component: <StatusTag status={'draft'} />,
    },
    {
      label: i18n.t('performance_process.reviews.review_status.active'),
      value: 'active',
      component: <StatusTag status={'active'} />,
    },
    {
      label: i18n.t('performance_process.reviews.review_status.finished'),
      value: 'finished',
      component: <StatusTag status={'finished'} />,
    },
  ]

  return buildPerformanceReviewsDataTableFilter(source, {
    type: FilterType.String,
    default: false,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
      {
        kind: 'SingleChoice',
        operation: 'notEq',
        options,
      },
    ],
    identifier: 'statusFilter',
    path: 'status',
    title: i18n.t('performance_process.reviews.datatable.status'),
  })
}
